import React from 'react';
import DesktopSubmitLayout from '../DesktopSubmitLayout';
import ImagePreviewWithDisplayOptions from '../../common/ImagePreviewWithDisplayOptions';
import TitleField from '../../../fields/TitleField';
import DescriptionField from '../../../fields/DescriptionField';
import ApplicationFieldsGroup from '../../../fields/ApplicationFieldsGroup';
import GallerySelectField from '../../../fields/GallerySelectField';
import GroupSelectField from '../../../fields/GroupSelectField';
import PremiumGalleryField from '../../../fields/PremiumGalleryField';
import DisableCommentsField from '../../../fields/DisableCommentsField';

interface Props {}

const ApplicationSubmitForm: React.FC<Props> = () => {
  return (
    <DesktopSubmitLayout preview={<ImagePreviewWithDisplayOptions />}>
      <TitleField />
      <DescriptionField />
      <ApplicationFieldsGroup />
      <GallerySelectField />
      <GroupSelectField />
      <PremiumGalleryField />
      <DisableCommentsField />
    </DesktopSubmitLayout>
  );
};
ApplicationSubmitForm.displayName = 'ApplicationSubmitForm';

export default ApplicationSubmitForm;
